import 'floating-vue/dist/style.css';

import FloatingVue from 'floating-vue';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(FloatingVue, {
    themes: {
      'teacher-calendar-tooltip': {
        $extend: 'dropdown',
        $resetCss: true,
        showTriggers: ['hover', 'focus', 'click'],
        hideTriggers: ['hover', 'focus'],
        distance: 8,
      },
    },
  });
});
